module.exports = __webpack_public_path__ + "static/other/waiter_memory.581d3c5a.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/waiter_memory.json
// module id = 2513
// module chunks = 0